import { useState } from "react";
import axios from "axios";
import { message } from "antd";
import { maintenanceService } from "../../../../configs/constants";

type CategoryType = "RES" | "COM" | "INT";

interface UseCategorySortParams {
  orgId?: string;
  maintenanceService?: string;
  type: CategoryType;
  categoryRoot?: [];
  parentKey?: string;
  dispatch?: any;
  parentID?: string;
  setType?: (value: string) => void;
  onUpdate?: () => void;
  valueRef?: any;
  categoryChangeType?: string;
}

export const useCategorySort = ({
  orgId,
  type,
  categoryRoot,
  parentKey,
  onUpdate,
  parentID,
}: UseCategorySortParams) => {
  const [loading, setLoading] = useState(false);

  const patchSortedCategories = async (sortedCategoryJson: any[], panelName = null) => {
    if (!orgId) {
      message.error("Organization ID Not Found. Please Reload.");
      return;
    }
    setLoading(true);
    try {
      const url = `${maintenanceService}/serviceprovider/category/${orgId}`;
      if (parentKey == null || !Array.isArray(categoryRoot) || !categoryRoot[parentKey]) {
        return;
      }
      let updatedCategoryRoot = [];
      if (panelName === "maintenance") {
        updatedCategoryRoot = sortedCategoryJson;
      } else {
        updatedCategoryRoot = categoryRoot.map((item: any, index) => {
          if (item?.categoryId === parentID) {
            return {
              ...item,
              subCategories: sortedCategoryJson,
            };
          } else {
            return item;
          }
        });
      }

      const payloadKey =
        type === "RES" ? "residentialCategories" : type === "COM" ? "commercialCategories" : "internalCategories";

      await axios.patch(url, {
        [payloadKey]: updatedCategoryRoot,
      });
      onUpdate();
      // message.success("Order updated successfully");
    } catch (err: any) {
      message.error(err?.response?.data?.message || "Failed to update category order");
    } finally {
      setLoading(false);
    }
  };

  return {
    patchSortedCategories,
    loading,
  };
};
